import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faUniversalAccess } from '@fortawesome/free-solid-svg-icons'

export default function Accessibility() {
  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <Navbar />
      <main className="pt-24 pb-16">
        <article className="max-w-3xl mx-auto px-4 sm:px-6 prose prose-slate">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-blue-600 mb-6 no-underline">
            <FontAwesomeIcon icon={faArrowLeft} className="w-3.5 h-3.5" />
            Kembali ke Beranda
          </a>
          <div className="flex items-center gap-3 mb-2">
            <FontAwesomeIcon icon={faUniversalAccess} className="w-6 h-6 text-blue-600" />
            <h1 className="text-3xl font-bold text-slate-900 m-0">Pernyataan Aksesibilitas</h1>
          </div>
          <p className="text-slate-500 text-sm">Terakhir diperbarui: Juni 2026</p>

          <h2>Komitmen Kami</h2>
          <p>
            Whistleblowing System (WBS) Pemerintah Provinsi Kalimantan Selatan berkomitmen
            meningkatkan aksesibilitas digital agar seluruh masyarakat dapat menggunakan layanan
            pelaporan dengan mudah, termasuk pengguna dengan keterbatasan visual, motorik, atau kognitif.
          </p>

          <h2>Fitur Aksesibilitas</h2>
          <ul>
            <li>Navigasi keyboard untuk elemen menu utama dan formulir.</li>
            <li>Kontras warna teks dan latar yang memadai pada halaman publik.</li>
            <li>Struktur heading dan label formulir yang jelas.</li>
            <li>Halaman legal dan bantuan tersedia tanpa harus masuk ke akun.</li>
          </ul>

          <h2>Bantuan & Umpan Balik</h2>
          <p>
            Jika Anda mengalami kendala aksesibilitas saat menggunakan sistem ini, hubungi kami melalui{' '}
            <a href="mailto:wbs@kalselprov.go.id">wbs@kalselprov.go.id</a> atau telepon (0511) 3252525.
            Umpan balik Anda membantu kami meningkatkan layanan.
          </p>

          <h2>Perbaikan Berkelanjutan</h2>
          <p>
            Kami meninjau dan memperbarui antarmuka secara berkala sesuai praktik terbaik aksesibilitas web
            dan kebutuhan pengguna di lapangan.
          </p>
        </article>
      </main>
      <Footer />
    </div>
  )
}
